import { render, staticRenderFns } from "./ClientInfoModal.vue?vue&type=template&id=5c645785&"
import script from "./ClientInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClientInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c645785')) {
      api.createRecord('5c645785', component.options)
    } else {
      api.reload('5c645785', component.options)
    }
    module.hot.accept("./ClientInfoModal.vue?vue&type=template&id=5c645785&", function () {
      api.rerender('5c645785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/ClientInfoModal.vue"
export default component.exports